import React, { useState } from "react";
import styled, { css } from "styled-components";
import colors from "styles/colors";
import typography from "styles/typography";
import Icon from "../Icon"; // Assuming you have a generic Icon component
import { ICON_SET } from "../Icon/IconSet";

const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  gap: 8px;
  transition: opacity 0.2s ease-in-out;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
    `}
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const CheckboxLabel = styled.span`
  font-family: ${typography.fontFamily};
  font-weight: ${typography.caption.semibold.fontWeight};
  font-size: ${typography.caption.semibold.fontSize};
  line-height: ${typography.caption.semibold.lineHeight};
  color: ${colors.text.primary};
`;

const Checkbox = ({ checked, defaultChecked, onChange, label, disabled }) => {
  const [internalChecked, setInternalChecked] = useState(
    defaultChecked || false
  );
  const isChecked = checked !== undefined ? checked : internalChecked;

  const handleChange = (e) => {
    e.preventDefault(); // Prevents unwanted parent event triggering
    if (disabled) return;

    const newChecked = !isChecked;
    if (onChange) {
      onChange(newChecked);
    }
    if (checked === undefined) {
      setInternalChecked(newChecked);
    }
  };

  return (
    <CheckboxWrapper
      disabled={disabled}
      role="checkbox"
      aria-checked={isChecked}
      onClick={handleChange}
    >
      <HiddenCheckbox checked={isChecked} readOnly />
      <Icon
        name={
          isChecked
            ? ICON_SET.checkBoxPostselected
            : ICON_SET.checkBoxUnselected
        }
        size={24}
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      />
      {label && <CheckboxLabel>{label}</CheckboxLabel>}
    </CheckboxWrapper>
  );
};

export default Checkbox;
